<template>
  <div id="ManifestPreview">
    <BreadCrumb :items="breadcrumbItems" />
    <v-row>
      <v-col cols="12">
        <v-card v-if="loading" elevation="1" class="py-5 px-5 mt-1 text-center">
          Aguarde, buscando dados
          <div class="mt20"></div>
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card>
        <v-card v-else elevation="1" :loading="loadingManifest" class="py-5 mt-1 loading-top">
          <div class="d-flex justify-space-between pa-5 align-center w-100">
            <h1 class="d-flex align-center">{{ namePage }}</h1>
            <div v-if="!importDetails" class="d-flex">
              <v-btn color="error" :loading="loadingDiscarded" large @click="approveImport(false)">
                Descartar Importação
              </v-btn>
              <v-tooltip top :disabled="isButtonDisabled">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-btn
                      color="info"
                      class="ml-3"
                      large
                      :loading="loadingCreate"
                      :disabled="!isButtonDisabled"
                      @click="approveImport()"
                    >
                      Importar dados
                    </v-btn>
                  </div>
                </template>
                <span class="tooltip-text" v-if="selectedMDFes.length == 0">Selecione o(s) MDF-e para importação</span>
                <span class="tooltip-text" v-else
                  >Previsão de pagamento obrigatória para adiantamento ou adicionais</span
                >
              </v-tooltip>
            </div>
          </div>
          <div class="divider"></div>

          <v-col class="px-5 pt-5" cols="12">
            <v-card elevation="1">
              <v-card-text class="pl-3">
                <div class="d-flex flex-row" style="height: auto">
                  <section class="d-flex flex-column" color="#0F416E" style="max-height: 590px">
                    <div class="d-flex justify-space-between align-items-center pt-3 pl-1">
                      <h1 class="text-left pt-1">Manifestos</h1>
                      <v-tooltip right nudge-top="1">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-checkbox
                              v-show="!importDetails"
                              v-model="selectAllManifest"
                              class="pa-0 ma-0"
                              hide-details
                              @change="toggleSelectAllManifest"
                            ></v-checkbox>
                          </div>
                        </template>
                        <span>Selecionar todos</span>
                      </v-tooltip>
                    </div>
                    <v-list class="manifest-list my-4">
                      <template v-for="(item, index) in manifestShipments">
                        <v-list-item
                          :key="item.id"
                          class="manifest-list-item text-left pa-0 set-text"
                          style="height: 48px"
                          :class="{
                            'selected-item': selectedItem === index,
                            'unselected-item': selectedItem !== index
                          }"
                        >
                          <template v-slot:default>
                            <v-tooltip right nudge-top="1" nudge-right="70">
                              <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="getAtribute(item.status) ? on : ''">
                                  <v-checkbox
                                    v-model="selectedMDFes"
                                    :value="item.id"
                                    :disabled="isDisabledMDFe(item.status)"
                                    :indeterminate="!statusMdfError || !statusMdfCompleted"
                                    :indeterminate-icon="viewIconMDFe(item.status)"
                                    color="primary"
                                    class="custom-checkbox ml-1"
                                    @change="checkSelectAll"
                                  ></v-checkbox>
                                </div>
                              </template>

                              <span
                                class="tooltip-text"
                                v-if="
                                  statusGeneralManifest !== 'Consulta Finalizada' &&
                                  item.status === 'Pronta para importar'
                                "
                              >
                                MDF-e não importado
                              </span>
                              <span class="tooltip-text" v-else>
                                {{ item.status === 'Duplicado' ? 'Já importado' : item.status }}
                              </span>
                            </v-tooltip>
                            <v-list-item-content @click="validationFinance(index)">
                              <v-list-item-title :class="statusClass(item.status)">{{ item.name }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list>
                  </section>

                  <v-divider class="mx-3" inset vertical></v-divider>
                  <div class="w-100">
                    <v-row class="justify-space-between">
                      <v-col cols="12" md="12">
                        <v-tabs v-model="tabProcessing" show-arrows>
                          <v-tab v-for="(item, index) in itemsProcessing" :key="index">
                            {{ item }}
                          </v-tab>
                        </v-tabs>
                      </v-col>
                    </v-row>

                    <section class="border-tab scroll no-border" v-show="tabProcessing === 0">
                      <v-row class="pt-3" v-if="itemProcessing != null">
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="itemProcessing.directDelivererName"
                            disabled
                            label="Motorista"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            disabled
                            v-model="itemProcessing.plateVehicle"
                            label="Placa veículo"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            disabled
                            v-model="itemProcessing.freightPrice"
                            v-money="money"
                            label="Preço da Viagem"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            disabled
                            v-model="itemProcessing.totalMileage"
                            label="Quilometragem total"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field disabled v-model="formattedCreatedAt" label="Data de Criação"></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="!statusMdfError && !statusMdfDuplicate">
                        <v-col cols="12" md="12"><div class="mt5"></div></v-col>
                        <v-col cols="12" md>
                          <div class="bg-azul-soma">
                            <img :src="t1" />
                            <div>
                              <div class="title-box">TRANSFERÊNCIAS</div>
                              <div class="text-box">{{ transfer }}</div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md>
                          <div class="bg-azul-soma">
                            <img :src="t2" />
                            <div>
                              <div class="title-box">CARGAS</div>
                              <div class="text-box">{{ loads }}</div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md>
                          <div class="bg-azul-soma">
                            <img :src="t3" />
                            <div>
                              <div class="title-box">PARADAS</div>
                              <div class="text-box">{{ stops }}</div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md>
                          <div class="bg-azul-soma">
                            <img :src="t4" />
                            <div>
                              <div class="title-box">ENTREGAS</div>
                              <div class="text-box">{{ deliveries }}</div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md>
                          <div class="bg-azul-soma">
                            <img :src="t5" />
                            <div>
                              <div class="title-box">NOTAS FISCAIS</div>
                              <div class="text-box">{{ nfe }}</div>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </section>
                    <section
                      class="section-style border-tab scroll no-border"
                      v-show="tabProcessing === 1 && statusMdfError"
                    >
                      <div v-if="statusMdfError && itemProcessing != null">
                        <div class="mt10"></div>
                        <v-simple-table class="w-100">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">NOTA FISCAL</th>
                                <th class="text-left">ERROS</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                class="text-left"
                                v-for="errorsItem of itemProcessing.errorsJson"
                                :key="errorsItem.line"
                              >
                                <td class="text-left">{{ errorsItem.line != 0 ? errorsItem.line : null }}</td>
                                <td class="pt-5">
                                  <p v-for="error in errorsItem.errors" :key="error">
                                    {{ error }}
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                      <p v-else>A tabela está sendo processada. Aguarde!</p>
                    </section>
                    <section
                      class="section-style border-tab scroll no-border"
                      v-show="tabProcessing === 1 && !statusMdfError && !statusMdfCompleted"
                    >
                      <v-row class="pt-3" style="margin: 0">
                        <v-col
                          class="title-table"
                          cols="12"
                          md
                          v-for="(col, indexStop) in columnsStopOptions"
                          :key="col.text + indexStop"
                          >{{ col.text }}</v-col
                        >
                      </v-row>
                      <template v-for="(node, nodeIndex) in nodesDirect">
                        <div :key="node.data.id + nodeIndex">
                          <v-row class="text-table" :class="nodeIndex % 2 !== 0 ? 'off' : ''">
                            <v-col
                              class="no-padding"
                              style="display: flex; align-items: flex-start"
                              cols="12"
                              md
                              v-for="(column, index) in columnsStops"
                              :key="column + index"
                            >
                              <span v-if="index === 0" @click="onExpand(node)">
                                <v-icon v-if="node.open"> mdi-chevron-down </v-icon>
                                <v-icon v-else> mdi-chevron-right </v-icon>
                              </span>
                              <span v-if="column === 'stopStatus'">
                                <span v-for="sticks in node.data[column]" :key="sticks.name">
                                  <v-chip color="info">
                                    {{ sticks.name }}
                                  </v-chip>
                                </span>
                              </span>
                              <span v-else> {{ node.data[column] }}</span>
                            </v-col>
                          </v-row>

                          <v-row v-if="node.open" style="margin-top: 0; width: 100%">
                            <v-col class="pa-0 pl-3" cols="12">
                              <v-card class="ml-1">
                                <v-card-text class="p-5">
                                  <v-row style="margin: 0">
                                    <v-col
                                      class="title-table"
                                      cols="12"
                                      md
                                      v-for="(column, indexCol) in columnsDeliveriesOptions"
                                      :key="column.text + indexCol"
                                      >{{ column.text }}</v-col
                                    >
                                  </v-row>
                                  <template v-for="(stop, stopIndex) in node.children">
                                    <div :key="stop.data.id + stopIndex">
                                      <v-row class="text-table" :class="stopIndex % 2 !== 0 ? 'off' : ''">
                                        <v-col
                                          class="no-padding"
                                          style="display: flex; align-items: flex-start; width: 100%"
                                          v-for="(columnDeliveries, columnDeliveriesIndex) in columnsDeliveries"
                                          :key="columnDeliveries + columnDeliveriesIndex"
                                        >
                                          <span v-if="columnDeliveriesIndex === 0" @click="onExpand(stop)">
                                            <v-icon v-if="stop.open"> mdi-chevron-down </v-icon>
                                            <v-icon v-else> mdi-chevron-right </v-icon>
                                          </span>

                                          <span v-if="columnDeliveries === 'deliveryStatus'">
                                            <span v-for="sticks in stop.data[columnDeliveries]" :key="sticks.name">
                                              <v-chip color="info">
                                                {{ sticks.name }}
                                              </v-chip>
                                            </span>
                                          </span>
                                          <span v-else>
                                            {{ stop.data[columnDeliveries] }}
                                          </span>
                                        </v-col>
                                      </v-row>
                                      <v-row v-if="stop.open" style="margin-top: 0; width: 100%">
                                        <v-col class="pa-0 pl-3" cols="12">
                                          <v-card>
                                            <v-card-text class="p-5">
                                              <v-row style="margin: 0">
                                                <v-col
                                                  class="title-table"
                                                  cols="12"
                                                  md
                                                  v-for="(column, colIndex) in columnsNfeOptions"
                                                  :key="column.text + colIndex"
                                                  >{{ column.text }}</v-col
                                                >
                                              </v-row>
                                              <v-row
                                                v-for="(nfe, nfeIndex) in stop.children"
                                                :key="nfe.data.accessKey + nfeIndex"
                                                class="text-table"
                                                :class="nfeIndex % 2 !== 0 ? 'off' : ''"
                                                style="width: 100%"
                                              >
                                                <v-col
                                                  class="no-padding"
                                                  style="display: flex; align-items: flex-start; width: 100%"
                                                  v-for="(columnNfe, indexNfe) in columnsNfe"
                                                  :key="columnNfe + indexNfe"
                                                >
                                                  <span>
                                                    {{ nfe.data[columnNfe] }}
                                                  </span>
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                          </v-card>
                                          <div class="mt20"></div>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </template>
                                </v-card-text>
                              </v-card>
                              <div class="mt20"></div>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                    </section>
                    <section
                      class="section-style border-tab scroll no-border"
                      v-show="tabProcessing === 2 && !statusMdfError && !statusMdfCompleted"
                    >
                      <v-row class="pt-3" style="margin: 0">
                        <v-col
                          class="title-table"
                          cols="12"
                          md
                          v-for="col in columnsTranshipmentOptions"
                          :key="col.text"
                          >{{ col.text }}</v-col
                        >
                      </v-row>
                      <template v-for="(node, nodeIndex) in nodes">
                        <div :key="node.data.id">
                          <v-row class="text-table" :class="nodeIndex % 2 !== 0 ? 'off' : ''">
                            <v-col
                              class="no-padding"
                              style="display: flex; align-items: flex-start"
                              cols="12"
                              md
                              v-for="(column, index) in columnsTranshipment"
                              :key="column + index"
                            >
                              <span v-if="index === 0" @click="onExpandNormal(node, node.key)">
                                <v-icon v-if="node.open"> mdi-chevron-down </v-icon>
                                <v-icon v-else> mdi-chevron-right </v-icon>
                              </span>
                              <span>
                                {{ node.data[column] }}
                              </span>
                            </v-col>
                          </v-row>

                          <v-row v-if="node.open" style="margin-top: 0; width: 100%">
                            <v-col class="pa-0 pl-3" cols="12">
                              <v-card class="ml-1">
                                <v-card-text class="p-5">
                                  <v-row style="margin: 0">
                                    <v-col
                                      class="title-table"
                                      cols="12"
                                      md
                                      v-for="column in columnsCargoOptions"
                                      :key="column.text"
                                      >{{ column.text }}</v-col
                                    >
                                  </v-row>
                                  <template v-for="(cargo, cargoIndex) in node.children">
                                    <div :key="cargo.data.id">
                                      <v-row class="text-table" :class="cargoIndex % 2 !== 0 ? 'off' : ''">
                                        <v-col
                                          class="no-padding"
                                          v-for="(columnCargo, indexCargo) in columnsCargo"
                                          :key="columnCargo + indexCargo"
                                          cols="12"
                                          md
                                        >
                                          <span v-if="indexCargo === 0" @click="onExpandNormal(cargo, node.key)">
                                            <v-icon v-if="cargo.open"> mdi-chevron-down </v-icon>
                                            <v-icon v-else> mdi-chevron-right </v-icon>
                                          </span>
                                          <span>
                                            {{ cargo.data[columnCargo] }}
                                          </span>
                                        </v-col>
                                      </v-row>

                                      <v-row v-if="cargo.open" style="margin-top: 0; width: 100%">
                                        <v-col class="pa-0 pl-3" cols="12">
                                          <v-card>
                                            <v-card-text class="p-5">
                                              <v-row style="margin: 0">
                                                <v-col
                                                  class="title-table"
                                                  v-for="column in columnsStopOptions"
                                                  :key="column.text"
                                                  cols="12"
                                                  md
                                                  >{{ column.text }}</v-col
                                                >
                                              </v-row>
                                              <template v-for="(stop, stopIndex) in cargo.children">
                                                <div :key="stop.data.id">
                                                  <v-row class="text-table" :class="stopIndex % 2 !== 0 ? 'off' : ''">
                                                    <v-col
                                                      class="no-padding"
                                                      v-for="(columnStops, columnStopsIndex) in columnsStops"
                                                      :key="columnStops"
                                                      cols="12"
                                                      md
                                                    >
                                                      <span
                                                        v-if="columnStopsIndex === 0"
                                                        @click="onExpandNormal(stop, node.key)"
                                                      >
                                                        <v-icon v-if="stop.open"> mdi-chevron-down </v-icon>
                                                        <v-icon v-else> mdi-chevron-right </v-icon>
                                                      </span>
                                                      <span>
                                                        {{ stop.data[columnStops] }}
                                                      </span>
                                                    </v-col>
                                                  </v-row>
                                                  <v-row v-if="stop.open" style="margin-top: 0; width: 100%">
                                                    <v-col cols="12">
                                                      <v-card>
                                                        <v-card-text class="p-5">
                                                          <v-row style="margin: 0">
                                                            <v-col
                                                              class="title-table"
                                                              v-for="column in columnsDeliveriesOptions"
                                                              :key="column.text"
                                                              cols="12"
                                                              md
                                                              >{{ column.text }}</v-col
                                                            >
                                                          </v-row>
                                                          <template
                                                            v-for="(deliveries, deliveriesIndex) in stop.children"
                                                          >
                                                            <div :key="deliveries.data.id">
                                                              <v-row
                                                                class="text-table"
                                                                :class="deliveriesIndex % 2 !== 0 ? 'off' : ''"
                                                              >
                                                                <v-col
                                                                  class="no-padding"
                                                                  v-for="(
                                                                    columnDeliveries, columnDeliveriesIndex
                                                                  ) in columnsDeliveries"
                                                                  :key="columnDeliveries.text"
                                                                  cols="12"
                                                                  md
                                                                >
                                                                  <span
                                                                    v-if="columnDeliveriesIndex === 0"
                                                                    @click="onExpandNormal(deliveries, node.key)"
                                                                  >
                                                                    <v-icon v-if="deliveries.open">
                                                                      mdi-chevron-down
                                                                    </v-icon>
                                                                    <v-icon v-else> mdi-chevron-right </v-icon>
                                                                  </span>
                                                                  <span>
                                                                    {{ deliveries.data[columnDeliveries] }}
                                                                  </span>
                                                                </v-col>
                                                              </v-row>

                                                              <v-row
                                                                v-if="deliveries.open"
                                                                style="margin-top: 0: width: 100%"
                                                              >
                                                                <v-col class="pa-0 pl-3" cols="12">
                                                                  <v-card>
                                                                    <v-card-text class="p-5">
                                                                      <v-row style="margin: 0">
                                                                        <v-col
                                                                          class="title-table"
                                                                          v-for="column in columnsNfeOptions"
                                                                          :key="column.text"
                                                                          cols="12"
                                                                          md
                                                                          >{{ column.text }}</v-col
                                                                        >
                                                                      </v-row>
                                                                      <template
                                                                        v-for="(nfe, nfeIndex) in deliveries.children"
                                                                      >
                                                                        <div :key="nfe.data.id">
                                                                          <v-row
                                                                            class="text-table"
                                                                            :class="nfeIndex % 2 !== 0 ? 'off' : ''"
                                                                          >
                                                                            <v-col
                                                                              class="no-padding"
                                                                              v-for="columnNfe in columnsNfe"
                                                                              :key="columnNfe + 'nfe'"
                                                                              cols="12"
                                                                              md
                                                                            >
                                                                              <div v-if="columnNfe === 'actions'">
                                                                                <v-menu offset-y>
                                                                                  <template
                                                                                    v-slot:activator="{ on, attrs }"
                                                                                  >
                                                                                    <v-icon
                                                                                      style="
                                                                                        font-size: 36px;
                                                                                        position: relative;
                                                                                        top: -6px;
                                                                                      "
                                                                                      color="black"
                                                                                      dense
                                                                                      large
                                                                                      v-bind="attrs"
                                                                                      v-on="on"
                                                                                    >
                                                                                      mdi-menu
                                                                                    </v-icon>
                                                                                  </template>
                                                                                  <v-list>
                                                                                    <v-list-item
                                                                                      v-for="(
                                                                                        item, indexDropdownNfe
                                                                                      ) in itemsDropdownNfe"
                                                                                      :key="indexDropdownNfe"
                                                                                      @click="
                                                                                        actionsDropdownNfe(
                                                                                          indexDropdownNfe
                                                                                        )
                                                                                      "
                                                                                    >
                                                                                      <v-list-item-title>{{
                                                                                        item.title
                                                                                      }}</v-list-item-title>
                                                                                    </v-list-item>
                                                                                  </v-list>
                                                                                </v-menu>

                                                                                <MoreSVG
                                                                                  class="ml-3"
                                                                                  role="button"
                                                                                  @click="openImportVolume()"
                                                                                />
                                                                              </div>
                                                                              <span v-else>
                                                                                <span>
                                                                                  {{ nfe.data[columnNfe] }}
                                                                                </span>
                                                                              </span>
                                                                            </v-col>
                                                                          </v-row>
                                                                        </div>
                                                                      </template>
                                                                    </v-card-text>
                                                                  </v-card>
                                                                  <div class="mt20"></div>
                                                                </v-col>
                                                              </v-row>
                                                            </div>
                                                          </template>
                                                        </v-card-text>
                                                      </v-card>
                                                      <div class="mt20"></div>
                                                    </v-col>
                                                  </v-row>
                                                </div>
                                              </template>
                                            </v-card-text>
                                          </v-card>
                                          <div class="mt20"></div>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </template>
                                </v-card-text>
                              </v-card>
                              <div class="mt20"></div>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                      <div class="mt50"></div>
                    </section>
                    <section
                      v-show="tabProcessing === 3 && !statusMdfError && !statusMdfCompleted"
                      class="section-style px-1"
                    >
                      <div class="pt-3">
                        <advance-form
                          :forecastPayment.sync="forecastPayment"
                          :advanceAmount.sync="advanceAmount"
                          :validateFields="true"
                          :validationOfAdditionals="this.additionalsDto.length > 0"
                          class="mb-6"
                        />
                        <div class="text-left">
                          <h1 class="mt-8 mb-4">Descrição dos Adicionais</h1>
                          <a href="#/financial/aditionals" target="_blank">
                            Clique aqui para incluir novos adicionais
                          </a>
                          <v-row dense class="my-4">
                            <v-col>
                              <related-aditionals-panel
                                credits-only
                                :applicationUserId="userId"
                                v-model="relatedAditionals"
                                :selectedAdditionals="selectedAdditionals"
                                :aditionalRelated="additionalsDto"
                                @clickAddAditionals="onClickAddRelatedAditional"
                              />
                            </v-col>
                          </v-row>
                          <aditionals-form
                            v-model="additionalsDto"
                            @relatedAditionalRemove="onRelatedAditionalRemove"
                            credits-only
                          >
                          </aditionals-form>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-form @submit.prevent="submit">
            <v-row class="px-5">
              <v-col cols="12" class="d-flex justify-end">
                <v-btn large color="info" @click="cancel()"> VOLTAR </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import RelatedAditionalsPanel from '@/components/AccountsPayable/RelatedAditionalsPanel.vue';
import AditionalsForm from '@/components/AditionalsForm.vue';
import AdvanceForm from '@/components/AdvanceForm.vue';
import MessagesError from '@/components/MessagesError.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';

import t1 from '../../../assets/img/t1.png';
import t2 from '../../../assets/img/t2.png';
import t3 from '../../../assets/img/t3.png';
import t4 from '../../../assets/img/t4.png';
import t5 from '../../../assets/img/t5.png';

import maskData from '../../../utils/maskData';
import maskCPF from '../../../utils/maskCPF';
import maskCNPJ from '../../../utils/maskCNPJ';
import maskPrice from '../../../utils/maskPrice';
import { VMoney } from 'v-money';
import { stringToMoneyMask } from '@/handlers/MoneyHandler.js';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';

export default {
  components: {
    BreadCrumb,
    MessagesError,
    AditionalsForm,
    AdvanceForm,
    RelatedAditionalsPanel
  },
  directives: { money: VMoney },

  data: () => ({
    userId: null,
    selectedItem: 0,
    loading: false,
    loadingManifest: false,
    tabProcessing: null,
    loadingCreate: false,
    loadingDiscarded: false,
    freightPrice: null,
    dataMDFes: [],
    selectedMDFes: [],
    selectAllManifest: false,
    totalMileage: null,
    forecastPayment: null,
    additionalsDto: [],
    selectedAdditionals: [],
    advanceAmount: null,
    relatedAditionals: [],
    financialValidation: true,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    columnsTranshipment: ['type', 'name'],
    columnsTranshipmentOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'name',
        text: 'Nome'
      }
    ],
    columnsCargo: ['type', 'boardingNumber'],
    columnsCargoOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'boardingNumber',
        text: 'N° Embarque Externo'
      }
    ],
    columns: ['type', 'cityName', 'recipientCpfOrCnpj', 'recipientName', 'transhipmentPrice'],
    columnOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cityName',
        text: 'Município'
      },
      {
        value: 'recipientCpfOrCnpj',
        text: 'CPF/CNPJ Destinatário'
      },
      {
        value: 'recipientName',
        text: 'Nome do Destinatário'
      },
      {
        value: 'transhipmentPrice',
        text: 'Preço do Transbordo'
      },
      {
        value: 'authorizationDate',
        text: 'Data de Autorização'
      },
      {
        value: 'costFreight',
        text: 'Preço do Frete'
      },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      },
      {
        value: 'emissionDate',
        text: 'Data de Emissão'
      },
      {
        value: 'senderName',
        text: 'Enviado por'
      },
      {
        value: 'price',
        text: 'Preço'
      },
      {
        value: 'weight',
        text: 'Peso'
      }
    ],
    columnsStops: ['type', 'cityName', 'stateName', 'street', 'cpfOrCnpj', 'transhipmentPrice'],
    columnsStopOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cityName',
        text: 'Cidade'
      },
      { value: 'stateName', text: 'Estado' },
      { value: 'street', text: 'Rua' },
      { value: 'cpfOrCnpj', text: 'CPF/CNPJ' }
    ],
    columnsDeliveries: ['type', 'cte_authorizationDate', 'cte_costFreight', 'cte_emissionDate', 'deliveryForecast'],
    columnsDeliveriesOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cte_authorizationDate',
        text: 'Data da Autorização'
      },
      { value: 'cte_costFreight', text: 'Preço do Frete' },
      { value: 'cte_emissionDate', text: 'Data da Emissão' },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      }
    ],
    columnsNfe: ['type', 'price', 'weight'],
    columnsNfeOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      { value: 'price', text: 'Preço da NF', expander: false, show: true },
      { value: 'weight', text: 'Peso da NF', expander: false, show: true }
    ],
    columnsDirect: [
      {
        field: 'type',
        header: 'Tipo',
        expander: true
      },
      { field: 'cityName', header: 'Cidade', expander: false },
      { field: 'stateName', header: 'Estado', expander: false },
      { field: 'street', header: 'Rua', expander: false },
      { field: 'cpfOrCnpj', header: 'CPF/CNPJ', expander: false },
      {
        field: 'cte_accessKey',
        header: 'CTE Chave de Acesso',
        expander: false
      },
      {
        field: 'cte_authorizationDate',
        header: 'Data da Autorização',
        expander: false
      },
      { field: 'cte_costFreight', header: 'Preço do Frete', expander: false },
      { field: 'cte_emissionDate', header: 'Data da Emissão', expander: false },
      {
        field: 'deliverer_document',
        header: 'Recipiente CPF/CNPJ',
        expander: false
      },
      { field: 'deliverer_name', header: 'Nome Recipiente', expander: false },
      {
        field: 'nfe_accessKey',
        header: 'NF-e Chave de Acesso',
        expander: false
      },
      { field: 'nfe_price', header: 'NF-e Preço', expander: false },
      { field: 'number', header: 'N°', expander: false }
    ],
    errors: [],
    error500: null,
    errorsType: 'error',
    itemProcessing: [],
    nodes: [],
    nodesDirect: [],
    manifestShipments: [],
    transfer: 0,
    loads: 0,
    stops: 0,
    deliveries: 0,
    nfe: 0,
    t1: t1,
    t2: t2,
    t3: t3,
    t4: t4,
    t5: t5,
    statusGeneralManifest: null,
    statusMdfError: false,
    statusMdfCompleted: false,
    statusMdfDuplicate: false,
    sequenceCode: null
  }),
  computed: {
    parameterID() {
      return this.$route.params.id;
    },
    namePage() {
      if (this.statusGeneralManifest === 'Importado com Sucesso') {
        return 'Visualizar MDF-e(s) Importados';
      } else if (this.statusGeneralManifest === 'Erro no processamento') {
        return 'Erros de Consulta/Importação de MDF-e(s)';
      } else {
        return 'Importação de MDF-e(s)';
      }
    },
    importDetails() {
      if (
        this.statusGeneralManifest === 'Importado com Sucesso' ||
        this.statusGeneralManifest === 'Erro no processamento' ||
        !this.dataMDFes.boardingsImport ||
        !this.dataMDFes.boardingsImport.some((mdf) => mdf.status === 'Pronta para importar')
      ) {
        return true;
      } else {
        return false;
      }
    },
    breadcrumbItems() {
      return [
        {
          text: 'Início',
          disabled: false,
          to: '/start'
        },
        {
          text: 'Manifestos',
          disabled: false,
          exact: true,
          to: '/imports/manifest-import'
        },
        {
          text: this.namePage,
          disabled: true,
          to: `/imports/manifest-import-preview/${this.parameterID}/details`
        }
      ];
    },
    itemsProcessing() {
      let withProcessing = ['DADOS GERAIS'];

      if (
        this.statusGeneralManifest === 'Consulta Finalizada' &&
        !this.statusMdfError &&
        !this.statusMdfCompleted &&
        !this.statusMdfDuplicate
      ) {
        withProcessing.push('ENTREGA DIRETA', 'TRANSFERÊNCIAS', 'FINANCEIRO');
      } else if (this.statusMdfError && !this.statusMdfCompleted) {
        withProcessing.push('ERROS');
      }
      return withProcessing;
    },
    isButtonDisabled() {
      this.hasValidFinancialData();
      const hasSeletedMDfes = this.selectedMDFes.length > 0;
      if (this.financialValidation && hasSeletedMDfes) {
        return true;
      } else {
        return false;
      }
    },
    formattedCreatedAt() {
      const createdAt = this.itemProcessing.createdAt;
      if (createdAt) {
        const dateObj = new Date(createdAt);
        const formattedDate = dateObj.toLocaleDateString('pt-BR');
        return formattedDate;
      } else {
        return '';
      }
    },
    hasRelatedAditional() {
      return this.relatedAditionals.length ? true : false;
    },
    hasRelatedAditionalsAdded() {
      return this.additionalsDto.some((aditional) => aditional.isRelatedAditional);
    }
  },

  async mounted() {
    if (this.parameterID) {
      this.loading = true;
      await this.resetData();
      await this.deleteAllFinanceData();
      this.selectAllManifest = false;
      this.manifestShipments = [];
      this.selectedItem = 0;
      this.selectedMDFes = [];
      await this.fetchManifestId(0, true);
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('ManifestStore', [
      'fetchManifestByID',
      'fetchManifest',
      'approveManifestImport',
      'discardManifestImport'
    ]),
    onClickAddRelatedAditional(relatedAditionals) {
      this.additionalsDto = [...this.additionalsDto, ...relatedAditionals];
    },
    onRelatedAditionalRemove(relatedAditional) {
      this.relatedAditionals = [...this.relatedAditionals, relatedAditional];
      this.selectedAdditionals = this.selectedAdditionals.filter((item) => item !== relatedAditional);
    },
    transformDate(date) {
      return maskData(date);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },
    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return money;
    },
    statusClass(status) {
      if (status === 'Concluído') {
        return 'green--text';
      } else if (status === 'Erro no processamento') {
        return 'red--text';
      } else if (status === 'Duplicado') {
        return 'orange--text';
      } else {
        return 'primary--text';
      }
    },
    isDisabledMDFe(status) {
      if (
        status === 'Erro no processamento' ||
        status === 'Concluído' ||
        status === 'Duplicado' ||
        this.statusGeneralManifest === 'Importado com Sucesso' ||
        this.statusGeneralManifest === 'Erro no processamento'
      ) {
        return true;
      } else {
        return false;
      }
    },
    getAtribute(status) {
      if (this.statusGeneralManifest === 'Consulta Finalizada' && status === 'Pronta para importar') {
        return false;
      } else {
        return true;
      }
    },
    viewIconMDFe(status) {
      if (status === 'Concluído') {
        return 'mdi-check-all';
      } else if (status === 'Erro no processamento') {
        return 'mdi-alert-circle';
      } else if (status === 'Duplicado') {
        return 'mdi-alert-outline';
      } else if (this.statusGeneralManifest !== 'Consulta Finalizada' && status === 'Pronta para importar') {
        return 'mdi-information';
      } else {
        return 'mdi-checkbox-blank-outline';
      }
    },
    toggleSelectAllManifest() {
      if (this.selectAllManifest) {
        this.selectedMDFes = this.manifestShipments
          .filter((item) => item.status === 'Pronta para importar')
          .map((item) => item.id);
      } else {
        this.selectedMDFes = [];
      }
    },
    checkSelectAll() {
      const allSelected = this.manifestShipments
        .filter((item) => item.status === 'Pronta para importar')
        .every((item) => this.selectedMDFes.includes(item.id));
      this.selectAllManifest = allSelected;
    },
    cancel() {
      this.$router.push('/imports/manifest-import');
    },
    saveFinanceData(sequenceCode) {
      let savedData = JSON.parse(localStorage.getItem('financeData')) || [];

      if (this.forecastPayment !== null && Number(this.transformPriceToSend(this.advanceAmount)) !== 0) {
        const existingIndex = savedData.findIndex((item) => item.sequenceCode == sequenceCode);

        const formData = {
          sequenceCode: sequenceCode,
          forecastPayment: this.forecastPayment,
          advanceAmount: this.advanceAmount,
          additionalsDto: this.additionalsDto
        };

        if (existingIndex !== -1) {
          savedData[existingIndex] = formData;
        } else {
          savedData.push(formData);
        }
        localStorage.setItem('financeData', JSON.stringify(savedData));
      }
    },

    loadFinanceData(sequenceCode) {
      const savedData = JSON.parse(localStorage.getItem('financeData')) || [];
      const formData = savedData.find((item) => item.sequenceCode == sequenceCode);

      if (formData) {
        this.forecastPayment = formData.forecastPayment;
        this.advanceAmount = formData.advanceAmount;
        this.additionalsDto = formData.additionalsDto;
      }

      this.selectedAdditionals = [];
      savedData.forEach((data) => {
        if (data.additionalsDto) {
          this.selectedAdditionals.push(data.additionalsDto);
        }
      });
    },
    deleteAllFinanceData() {
      localStorage.removeItem('financeData');
    },
    async fetchManifestId(index, manifestColumn = false) {
      this.loadingManifest = true;
      this.selectedItem = index;
      try {
        if (manifestColumn) {
          this.dataMDFes = await this.fetchManifestByID(this.parameterID);
          this.dataMDFes.boardingsImport.sort((a, b) => a.sequenceCodeIntegrationEsl - b.sequenceCodeIntegrationEsl);
          this.statusGeneralManifest = this.dataMDFes.status;
          this.manifestShipments = this.dataMDFes.boardingsImport.map((item) => ({
            name: 'MDF-e ' + item.sequenceCodeIntegrationEsl,
            id: item.sequenceCodeIntegrationEsl,
            status: item.status
          }));
        } else {
          await this.saveFinanceData(this.sequenceCode);
          await this.resetData();
          const sequenceCode = this.dataMDFes.boardingsImport[index].sequenceCodeIntegrationEsl;
          await this.loadFinanceData(sequenceCode);
        }
        const dados = this.dataMDFes.boardingsImport[index];
        this.sequenceCode = dados.sequenceCodeIntegrationEsl;
        this.userId = dados.userId;
        const statusByMDFe = dados.status;
        if (statusByMDFe === 'Erro no processamento') {
          this.statusMdfError = true;
        }
        if (statusByMDFe === 'Concluído') {
          this.statusMdfCompleted = true;
        }
        if (statusByMDFe === 'Duplicado') {
          this.statusMdfDuplicate = true;
        }
        if (dados.dataJson && statusByMDFe !== 'Erro no processamento') {
          this.CargaHierarchy(dados);
        }
        this.itemProcessing = { ...dados, freightPrice: stringToMoneyMask(dados.freightPrice) };
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingManifest = false;
      }
    },

    CargaHierarchy(processedData) {
      const cargaOrdered = processedData.dataJson.cargos.sort((a, b) => {
        return a.isDirectDelivery === b.isDirectDelivery ? 0 : a.isDirectDelivery ? 1 : -1;
      });

      const processedCarga = cargaOrdered.map((item, index) => {
        const stops = this.StopsHierarchy(item.stops, index);
        const newCargaItem = this.createCargoItem(item, stops, index);
        return newCargaItem;
      });

      this.NodesDirectAndTranshipmentHierarchy(processedData, processedCarga);
    },

    StopsHierarchy(stops, cargoIndex) {
      return stops.map((itemStop, stopIndex) => {
        const deliverers = this.DeliverersHierarchy(itemStop.deliveries, cargoIndex, stopIndex);
        const newStopItem = this.createStopItem(itemStop, deliverers, cargoIndex, stopIndex);
        return newStopItem;
      });
    },

    DeliverersHierarchy(deliveries, cargoIndex, stopIndex) {
      return deliveries.map((itemDeliverer, delivererIndex) => {
        const nfes = this.NfesHierarchy(itemDeliverer.nfes, cargoIndex, stopIndex, delivererIndex);
        const newDelivererItem = this.createDelivererItem(itemDeliverer, nfes, cargoIndex, stopIndex, delivererIndex);
        return newDelivererItem;
      });
    },

    NfesHierarchy(nfes, cargoIndex, stopIndex, delivererIndex) {
      return nfes.map((itemNfe, nfeIndex) => {
        return {
          key: `${cargoIndex}-${stopIndex}-${delivererIndex}-${nfeIndex}`,
          data: {
            ...itemNfe,
            nfe_accessKey: itemNfe.accessKey,
            nfe_price: maskPrice(itemNfe.price),
            type: 'Nota Fiscal'
          }
        };
      });
    },

    createCargoItem(item, stops, index) {
      return {
        key: index,
        data: {
          ...item,
          type: 'Carga'
        },
        children: stops,
        open: false
      };
    },

    createStopItem(itemStop, deliverers, cargoIndex, stopIndex) {
      return {
        key: `${cargoIndex}-${stopIndex}`,
        data: {
          ...itemStop,
          ...itemStop.recipient,
          ...itemStop.recipient.address,
          type: 'Parada',
          cpfOrCnpj: this.transformCpfOrCnpj(itemStop.recipient.cpfOrCnpj),
          transhipmentPrice: maskPrice(itemStop.transhipmentPrice || 0)
        },
        children: deliverers,
        open: false
      };
    },

    createDelivererItem(itemDeliverer, nfes, cargoIndex, stopIndex, delivererIndex) {
      return {
        key: `${cargoIndex}-${stopIndex}-${delivererIndex}`,
        data: {
          ...itemDeliverer,
          deliverer_name: itemDeliverer.sender,
          cte_accessKey: itemDeliverer.cte.accessKey,
          deliveryForecast: this.transformDate(itemDeliverer.deliveryForecast),
          cte_authorizationDate: this.transformDate(itemDeliverer.cte.authorizationDate),
          cte_costFreight: itemDeliverer.cte.costFreight,
          cte_emissionDate: this.transformDate(itemDeliverer.cte.emissionDate),
          cte_id: itemDeliverer.cte.id,
          cte_number: itemDeliverer.cte.number,
          type: 'Entrega'
        },
        children: nfes,
        open: false
      };
    },

    NodesDirectAndTranshipmentHierarchy(processedData, processedCargo) {
      const newNodesDirects = processedCargo.filter((item) => {
        return item.data.isDirectDelivery;
      });

      const newNodes = processedCargo.filter((item) => {
        return item.data.isDirectDelivery === false;
      });

      let nodesDirectsNew = [];

      newNodesDirects.map((item) => {
        return nodesDirectsNew.push(...item.children);
      });
      const nodesDirect = nodesDirectsNew.map((item) => {
        const childrens = item.children.map((itemChildren) => {
          const itensChildren = {
            children: itemChildren.children,
            data: {
              ...itemChildren.data
            },
            key: itemChildren.key,
            open: false
          };

          const itensChildrens = itensChildren.children.map((itemNFe) => {
            const nfeChildren = {
              data: {
                ...itemNFe.data
              },
              key: itemNFe.key
            };

            return nfeChildren;
          });

          return {
            key: itensChildren.key,
            children: itensChildrens,
            data: itensChildren.data,
            open: false
          };
        });

        return {
          key: item.key,
          children: childrens,
          data: item.data,
          open: false
        };
      });

      this.nodesDirect = nodesDirect;
      this.nodes = newNodes;

      let transhipmentNameList = [];

      const resultTransfer = newNodes.reduce(
        (acc, current) => {
          const has = acc[0].some((ele) => ele.data.transhipmentName === current.data.transhipmentName);
          if (has) {
            const _has = acc[1].some((ele) => {
              ele.data.transhipmentName === current.data.transhipmentName;
            });
            if (!_has) {
              acc[1] = [...acc[1], current];
            }
          } else {
            acc[0] = [...acc[0], current];
          }
          if (!transhipmentNameList.includes(current.data.transhipmentName)) {
            transhipmentNameList.push(current.data.transhipmentName);
          }
          return acc;
        },
        [[], []]
      );

      let transhipments = [];
      transhipmentNameList.map((item, index) => {
        const t = {
          key: index,
          data: { name: item, type: 'Transbordo' },
          children: [],
          open: false
        };
        this.nodes.map((node) => {
          if (node.data.transhipmentName === item) {
            t.children.push(node);
          }
        });
        transhipments.push(t);
      });

      this.nodes = transhipments;

      this.transfer = resultTransfer[0].length;

      this.loads = processedData.dataJson.cargos.length;

      processedData.dataJson.cargos.map((item) => {
        this.stops = this.stops + item.stops.length;

        item.stops.map((itemStops) => {
          this.deliveries = this.deliveries + itemStops.deliveries.length;

          itemStops.deliveries.map((itemDeliverer) => {
            this.nfe = this.nfe + itemDeliverer.nfes.length;
          });
        });
      });
    },
    onExpand(item) {
      if (item.data.type === 'Parada') {
        const stopIndex = item.key.split('-')[1];
        this.nodesDirect[stopIndex].open = !this.nodesDirect[stopIndex].open;
      }
      if (item.data.type === 'Entrega') {
        const stopIndex = item.key.split('-')[1];
        const deliveryIndex = item.key.split('-')[2];
        this.nodesDirect[stopIndex].children[deliveryIndex].open =
          !this.nodesDirect[stopIndex].children[deliveryIndex].open;
      }
    },
    onExpandNormal(item, nodeKey) {
      if (item.data.type === 'Transbordo') {
        this.nodes[nodeKey].open = !this.nodes[nodeKey].open;
      } else if (item.data.type === 'Carga') {
        const cargaNode = this.nodes[nodeKey]?.children.find((car) => car.key === item.key);
        cargaNode.open = !cargaNode.open;
      } else if (item.data.type === 'Parada') {
        const cargoIndex = item.key.split('-')[0];
        const stopIndex = item.key.split('-')[1];
        const stopNode = this.nodes[nodeKey]?.children.find((car) => car.key == cargoIndex).children[stopIndex];
        stopNode.open = !stopNode.open;
      } else if (item.data.type === 'Entrega') {
        const cargoIndex = item.key.split('-')[0];
        const stopIndex = item.key.split('-')[1];
        const deliveryIndex = item.key.split('-')[2];
        const deliveryNode = this.nodes[nodeKey]?.children.find((car) => car.key == cargoIndex).children[stopIndex]
          .children[deliveryIndex];
        deliveryNode.open = !deliveryNode.open;
      }
    },
    resetData() {
      this.userId = null;
      this.itemProcessing = null;
      this.statusMdfError = false;
      this.statusMdfCompleted = false;
      this.statusMdfDuplicate = false;
      this.transfer = 0;
      this.loads = 0;
      this.stops = 0;
      this.tabProcessing = 0;
      this.deliveries = 0;
      this.nfe = 0;
      this.nodes = null;
      this.nodesDirect = null;
      this.forecastPayment = null;
      this.additionalsDto = [];
      this.advanceAmount = null;
    },
    closeDialog() {
      this.resetData();
      this.deleteAllFinanceData();
      this.$emit('close');
    },
    hasValidFinancialData() {
      const hasAdvance = this.advanceAmount ? Number(this.transformPriceToSend(this.advanceAmount)) > 0 : false;
      const hasAdditionals = this.additionalsDto.length > 0;
      const hasPaymentForecast = this.forecastPayment !== null;
      if (!hasAdvance && !hasAdditionals && !hasPaymentForecast) {
        this.financialValidation = true;
      } else if (hasPaymentForecast && hasAdvance && hasAdditionals) {
        this.financialValidation = true;
      } else if (hasPaymentForecast && hasAdvance) {
        this.financialValidation = true;
      } else {
        this.financialValidation = false;
      }
    },
    async validationFinance(index) {
      await this.hasValidFinancialData();
      if (this.financialValidation) {
        this.fetchManifestId(index);
      } else {
        this.errorsType = 'error';
        this.errors = ['Preencha todos os campos financeiros obrigatórios.'];
      }
    },

    async approveImport(bool = true) {
      if (bool) {
        this.loadingCreate = true;
      } else {
        this.loadingDiscarded = true;
      }
      try {
        let requestData = {
          id: this.parameterID,
          sequenceCodes: this.selectedMDFes
        };
        if (bool) {
          this.saveFinanceData(this.sequenceCode);
          const savedData = JSON.parse(localStorage.getItem('financeData')) || [];

          if (savedData.length > 0) {
            const formattedData = savedData.map((item) => ({
              ...item,
              advanceAmount: Number(this.transformPriceToSend(item.advanceAmount))
            }));

            const importManifest = this.selectedMDFes.map((sequenceCode) => {
              const relatedFinance = formattedData.find((item) => item.sequenceCode == sequenceCode);
              if (relatedFinance) {
                return {
                  advanceAmount: relatedFinance.advanceAmount,
                  paymentForecast: relatedFinance.forecastPayment,
                  additionals: {
                    id: relatedFinance.additionalsDto.map((additional) => additional.id)
                  },
                  sequenceCode: relatedFinance.sequenceCode
                };
              }
            });

            requestData = {
              ...requestData,
              advancesOnImportDto: importManifest
            };
          }
          const data = await this.approveManifestImport(requestData);
          if (data.success) {
            const message = 'MDF-e(s) estão sendo processados!';
            FeedbackMessageHandler.setFeedbackMessage(this, message);
          } else {
            const message = 'Erro ao importar MDF-e(s)!';
            FeedbackMessageHandler.setFeedbackMessage(this, message);
          }
        } else {
          const data = await this.discardManifestImport(requestData);
          if (data.success) {
            const message = 'Importação de MDF-e(s) descartada com sucesso!';
            FeedbackMessageHandler.setFeedbackMessage(this, message);
          } else {
            const message = 'Erro ao descartar MDF-e(s)!';
            FeedbackMessageHandler.setFeedbackMessage(this, message);
          }
        }
        this.$router.push('/imports/manifest-import');
      } catch (err) {
        console.error(err);
        this.errorsType = 'error';
        this.errors = ['Opss, algo deu errado!', err.message];
      } finally {
        this.loadingCreate = false;
        this.loadingDiscarded = false;
      }
    },
    handleFeedback(data, isApprove) {
      if (data.success) {
        this.errorsType = 'success';
        this.$emit('close');
        if (isApprove) {
          this.errors = ['Manifesto importado com sucessso!'];
        } else {
          this.errors = ['Manifesto descartado com sucessso!'];
        }
      } else {
        this.errorsType = 'error';
        this.errors = data.errors;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-file-input__text {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  top: -6px !important;
  position: relative !important;
  left: 145px !important;
  width: auto !important;
}

.p-treetable table {
  min-width: 100%;
  width: auto;
}

.p-treetable-tbody,
.p-treetable-thead {
  span {
    padding-left: 30px;
    white-space: nowrap;
  }
}

.tooltip-text {
  white-space: nowrap;
}
.loading-top .v-card__actions {
  justify-content: flex-start;
  align-items: flex-start;
}

.loading-top .v-card__progress {
  margin-top: 100px;
}
.close-right {
  position: absolute;
  right: 30px;
  top: 30px;
}
.section-style {
  height: 480px;
  width: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.manifest-list {
  height: auto;
  max-height: 590px;
  width: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.manifest-list-item {
  cursor: pointer;
}
.section-style::-webkit-scrollbar,
.manifest-list::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

.section-style::-webkit-scrollbar-track,
.manifest-list::-webkit-scrollbar-track {
  padding-left: 1px;
  padding-right: 1px;
  background-color: #f5f5f5 !important;
}

.section-style::-webkit-scrollbar-thumb,
.manifest-list::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
::v-deep .v-input--is-disabled .mdi-alert-circle {
  color: #ff0000;
}
::v-deep .v-slide-group__prev .v-slide-group__prev--disabled {
  display: none;
}

::v-deep .v-input--is-disabled .mdi-alert-outline {
  color: #ff7f0e;
}
::v-deep .v-input--is-disabled .mdi-check-all {
  color: #008000;
}
::v-deep .v-input--checkbox .mdi-checkbox-blank-outline,
::v-deep .v-input--is-disabled .mdi-information {
  color: #1976d2;
}
.selected-item {
  background-color: rgb(158, 158, 158, 0.3);
}
.unselected-item:hover {
  background-color: rgb(158, 158, 158, 0.1);
}

@media (max-width: 1540px) {
  img {
    display: none;
  }

  .bg-azul-soma .text-box {
    text-align: center;
  }
}
</style>
